export default {
  CHIME: 'CHIME',
  AGORA: 'AGORA'
}
